import { render, staticRenderFns } from "./inpatientRecords.vue?vue&type=template&id=cc868fb0&scoped=true"
import script from "./inpatientRecords.vue?vue&type=script&lang=js"
export * from "./inpatientRecords.vue?vue&type=script&lang=js"
import style0 from "./inpatientRecords.vue?vue&type=style&index=0&id=cc868fb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc868fb0",
  null
  
)

export default component.exports